import { Link } from 'react-router-dom'
import { cn } from '@/lib/cn'
import { FacebulMark } from './facebul-mark'

export function Brand({ compact = false, className }: { compact?: boolean; className?: string }) {
  return <Link to="/events" className={cn('inline-flex items-center gap-2.5 text-ink', className)} aria-label="Facebul">
    <FacebulMark className="size-9 shrink-0" />
    {!compact && <span className="text-[19px] font-extrabold tracking-[-.045em]">facebul<span className="text-brand">.com</span></span>}
  </Link>
}
